import React from "react";
const Workflow = () => {
    return <h1>Workflow Page</h1>;
};
export default Workflow;